import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {
  MatDatepicker,
  MatDatepickerActions,
  MatDatepickerApply,
  MatDatepickerCancel,
  MatDateRangeInput,
  MatDateRangePicker,
  MatEndDate,
  MatStartDate
} from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomNativeDateAdapter } from '../../config/date-adapter/custom-native-date-adapter.service';
import { CUSTOM_NATIVE_DATE_FORMATS } from '../../config/date-adapter/custom-date-formats';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { toUTCString } from '../../config/date-adapter/date-formatter';
import { NoDateSwitchComponent } from './components/no-date-switch/no-date-switch.component';

export interface DateRangeFacet {
  from: string | null;
  to: string | null;
}

export interface EmittedDateRangeFacet {
  columnKey: string;
  filterKey: string;
  values?: DateRangeFacet;
}

@Component({
  selector: 'app-date-range-facet-filter',
  standalone: true,
  templateUrl: './date-range-facet-filter.component.html',
  imports: [
    MatDateRangePicker,
    MatDateRangeInput,
    ReactiveFormsModule,
    MatStartDate,
    MatEndDate,
    MatButton,
    MatDatepickerCancel,
    MatDatepickerActions,
    MatDatepickerApply,
    NoDateSwitchComponent
  ],
  styleUrl: './date-range-facet-filter.component.scss',
  providers: [
    { provide: DateAdapter, useClass: CustomNativeDateAdapter },
    {
      provide: MAT_DATE_FORMATS,
      useValue: CUSTOM_NATIVE_DATE_FORMATS
    }
  ]
})
export class DateRangeFacetFilterComponent {
  @ViewChild(MatDatepicker, { static: true }) picker!: MatDatepicker<any>;
  @ViewChild(NoDateSwitchComponent, { static: true }) noDateSwitchComponent!: NoDateSwitchComponent;
  @Input() columnKey = '';
  @Output() selectedDates = new EventEmitter<EmittedDateRangeFacet>();
  dateRangeGroup = new FormGroup({
    from: new FormControl<Date | null>(null),
    to: new FormControl<Date | null>(null)
  });
  dateFilter: (d: Date | null) => boolean = () => true;
  isPickerEnabled = true;

  apply() {
    if (this.isPickerEnabled) {
      const { from, to } = this.dateRangeGroup.getRawValue() as { from: Date | null; to: Date | null };
      if (!from && !to) {
        return;
      }
      const fromString = this.isPickerEnabled ? toUTCString(new Date(from!.setHours(0, 0, 0))) : null;
      const toString = this.isPickerEnabled ? toUTCString(new Date((to ?? from)!.setHours(23, 59, 59))) : null;
      this.selectedDates.emit({
        columnKey: this.columnKey,
        filterKey: 'range',
        values: { from: fromString, to: toString }
      });
    } else {
      this.selectedDates.emit({ columnKey: this.columnKey, filterKey: 'hasNoValue' });
    }
  }

  reset() {
    this.dateRangeGroup.reset({ from: null, to: null });
    this.noDateSwitchComponent.toggle(true);
    this.selectedDates.emit({ columnKey: this.columnKey, filterKey: 'range', values: { from: null, to: null } });
  }

  noDate(checked: boolean) {
    this.isPickerEnabled = checked;
    if (this.isPickerEnabled) {
      this.dateFilter = () => true;
    } else {
      this.dateFilter = () => false;
      this.dateRangeGroup.reset({ from: null, to: null });
    }
  }
}
